

































import { Vue, Component, Prop } from 'vue-property-decorator';
import { BrandLogoViewModel, FacetViewObject, FacetValueViewObject } from '@/types/apiServerContract';
import Api from '@/project/http/Api.service';
import adnuntiusService from '@/project/personalization/adnuntius.service';
import AdnuntiusPixels from '@/project/tracking/adnuntius/AdnuntiusPixels.vue';

@Component({
    components: { AdnuntiusPixels }
})
export default class FacetPickerRecommendedBrands extends Vue {
    @Prop({ required: true, type: Object })
    private facet!: FacetViewObject;

    @Prop({ required: true, type: Function })
    private toggle!: (value: FacetValueViewObject, facet: FacetViewObject) => void;

    @Prop({ type: Boolean, default: true })
    private showTitle!: boolean;

    @Prop({ type: Boolean, default: false })
    private showCount!: boolean;

    private recommendedBrands: BrandLogoViewModel[] = [];

    private get brands() {
        return this.facet.values.map(x => x.key);
    }

    private get recommendedBrandsFacets() {
        return this.facet.values
            .filter(x => this.recommendedBrands.some(b => b.name === x.key))
            .map(facet => ({
                facet,
                brand: this.getBrandData(facet.key)
            }));
    }

    private getBrandData(key: string) {
        return this.recommendedBrands.find(x => x.name === key);
    }

    private handleClick(value: FacetValueViewObject, adnuntiusClickHandler: Function) {
        this.toggle(value, this.facet);
        adnuntiusClickHandler();
    }

    private async fetchRecommendedBrands() {
        this.recommendedBrands = await Api.personalization.recommendedBrands(
            this.brands,
            this.$route.fullPath,
            adnuntiusService.getContactKey(),
            adnuntiusService.getCustomerKey());

        this.$emit('showRecommendedBrands', this.recommendedBrands.length > 0);
    }

    created() {
        this.fetchRecommendedBrands();
    }
}
